import React, { useEffect,useState } from 'react'
import _ from 'lodash';

import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectOpenNetworkProductTypesQueryItems } from '../../../../../redux/opennetwork-product-types/selector';
import { openNetworkProductTypes } from '../../../../../redux/opennetwork-product-types/action';
import { OpenNetworkProductTypeComponent } from '../components/opennetwork-product-type.component';
import PageLoader from '../../../../../components/PageLoader';



const OpenNetworkProductType= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectOpenNetworkProductTypesQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedProductType,
    setSelectedProductType
  ] = useState<any>([])
 
  const fetchOpenNetworkProductTypeById= ()=>{
    dispatch(openNetworkProductTypes.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types/query`,entity:'openNetworkProductTypes',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedProductType({ ...selectedProductType, [field]: event });
  }

  useEffect(
    () => {
     
      if (parmas?.id > 0) {
        fetchOpenNetworkProductTypeById()
        setIsLoading(false)

      }
      else{
        setIsLoading(false)

      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedProductType(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(openNetworkProductTypes.resetAction({ actionType: 'update' }))
      await dispatch(openNetworkProductTypes.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types`,entity:'openNetworkProductTypes',jsonData:{
          
    Records: [
      {
        
       
         ...selectedProductType
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(openNetworkProductTypes.resetAction({ actionType: 'create' }))
      await dispatch(openNetworkProductTypes.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/opennetwork-product-types`,entity:'openNetworkProductTypes',jsonData:{
          
      Records: [
        {
        
         
            ...selectedProductType
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/dbn/product-types')
} 

    return (
    <>
        {isLoading ? <PageLoader /> : 
          <OpenNetworkProductTypeComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedProductType={selectedProductType}
           back={back}
           handleFormSubmit={handleFormSubmit}
          />  
    }
          </>
    )
    
    }
   
    export default OpenNetworkProductType;
